<template>
  <div>
    <!-- <Header /> -->

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-5 pt-5">
          <!-- Organization Title -->
          <!-- <div class="flex h-10 py-1 px-2 md:px-6 text-[#0085DB]">
            <div
              v-if="organizationdetaill != null"
              class="text-lg lg:text-2xl font-semibold capitalize"
            >
              {{ organizationdetaill.title }}
            </div>
          </div> -->
          <div class="p-6">
            <MonthChart />
          </div>

          <!--  count details -->
          <div
            class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6 p-6"
            v-if="studentlist"
          >
            <!-- Card -->
            <router-link :to="{ name: 'HodStudentDetail' }">
              <div
                class="bg-white shadow-md rounded-2xl p-6 flex flex-col gap-4"
              >
                <div class="flex justify-between items-center">
                  <div class="flex items-center gap-3">
                    <div
                      class="bg-gradient-to-br from-blue-500 to-blue-700 text-white p-2 flex justify-center items-center rounded-xl"
                    >
                      <img
                        src="@/assets/Admin/Vector(17).png"
                        alt=""
                        srcset=""
                        class="object-contain w-5 h-5"
                      />
                    </div>
                    <h2 class="font-semibold text-gray-700 text-sm 2xl:text-lg">
                      Students 
                    </h2>
                  </div>
                  <div
                    class="bg-gray-100 text-green-600 text-sm font-medium px-3 py-1 rounded-md shadow flex gap-1 items-center"
                  >
                    <img
                      src="@/assets/Admin/icon.png"
                      alt=""
                      srcset=""
                      class="object-contain"
                    />
                    +{{ studentlist.recent_student_percent }}%
                  </div>
                </div>
                <div>
                  <p class="text-2xl font-bold text-gray-800">
                    <span v-if="studentlist.recent_student_count">{{
                      studentlist.recent_student_count
                    }}</span>
                    <span v-else>NA</span>
                  </p>
                  <p class="text-sm text-gray-500">
                    Total Student
                    <span class="text-blue-500 font-medium">
                      <span v-if="studentlist.student_count">{{
                        studentlist.student_count
                      }}</span>
                      <span v-else>NA</span></span
                    >
                  </p>
                </div>
              </div>
            </router-link>

            <router-link :to="{ name: 'HodStaffDetails' }">
              <div
                class="bg-white shadow-md rounded-2xl p-6 flex flex-col gap-4"
              >
                <div class="flex justify-between items-center">
                  <div class="flex items-center gap-3">
                    <div
                      class="bg-gradient-to-br from-[#1AD598] to-[#1AD598] text-white p-2 flex justify-center items-center rounded-xl"
                    >
                      <img
                        src="@/assets/Admin/Vector(17).png"
                        alt=""
                        srcset=""
                        class="object-contain w-5 h-5"
                      />
                    </div>
                    <h2 class="font-semibold text-gray-700 text-sm 2xl:text-lg">
                      Staffs 
                    </h2>
                  </div>
                  <div
                    class="bg-gray-100 text-green-600 text-sm font-medium px-3 py-1 rounded-md shadow flex gap-1 items-center"
                  >
                    <img
                      src="@/assets/Admin/icon.png"
                      alt=""
                      srcset=""
                      class="object-contain"
                    />
                    +{{ studentlist.staff_recent_percent }}%
                  </div>
                </div>
                <div>
                  <p class="text-2xl font-bold text-gray-800">
                    <span v-if="studentlist.staff_recent_count">{{
                      studentlist.staff_recent_count
                    }}</span>
                    <span v-else>NA</span>
                  </p>
                  <p class="text-sm text-gray-500">
                    Total Staff
                    <span class="text-[#1AD598] font-medium">
                      <span v-if="studentlist.staff_count">{{
                        studentlist.staff_count
                      }}</span>
                      <span v-else>NA</span></span
                    >
                  </p>
                </div>
              </div>
            </router-link>

            <router-link :to="{ name: 'HodSemesterDetails' }">
              <div
                class="bg-white shadow-md rounded-2xl p-6 flex flex-col gap-4"
              >
                <div class="flex justify-between items-center">
                  <div class="flex items-center gap-3">
                    <div
                      class="bg-gradient-to-br from-[#A839DB] to-[#A839DB] text-white p-2 flex justify-center items-center rounded-xl"
                    >
                      <img
                        src="@/assets/Admin/Vector(17).png"
                        alt=""
                        srcset=""
                        class="object-contain w-5 h-5"
                      />
                    </div>
                    <h2 class="font-semibold text-gray-700 text-sm 2xl:text-lg">
                      Semesters 
                    </h2>
                  </div>
                  <div
                    class="bg-gray-100 text-green-600 text-sm font-medium px-3 py-1 rounded-md shadow flex gap-1 items-center"
                  >
                    <img
                      src="@/assets/Admin/icon.png"
                      alt=""
                      srcset=""
                      class="object-contain"
                    />
                    +100%
                  </div>
                </div>
                <div>
                  <p class="text-2xl font-bold text-gray-800">
                    <span v-if="studentlist.semester_count">{{
                      studentlist.semester_count
                    }}</span>
                    <span v-else>NA</span>
                  </p>
                  <p class="text-sm text-gray-500">
                    Total Semester
                    <span class="text-[#A839DB] font-medium">
                      <span v-if="studentlist.semester_count">{{
                        studentlist.semester_count
                      }}</span>
                      <span v-else>NA</span></span
                    >
                  </p>
                </div>
              </div>
            </router-link>
            <router-link :to="{ name: 'HodBatchDetails' }">
              <div
                class="bg-white shadow-md rounded-2xl p-6 flex flex-col gap-4"
              >
                <div class="flex justify-between items-center">
                  <div class="flex items-center gap-3">
                    <div
                      class="bg-gradient-to-br from-[#DB9D39] to-[#DB9D39] text-white p-2 flex justify-center items-center rounded-xl"
                    >
                      <img
                        src="@/assets/Admin/Vector(17).png"
                        alt=""
                        srcset=""
                        class="object-contain w-5 h-5"
                      />
                    </div>
                    <h2 class="font-semibold text-gray-700 text-sm 2xl:text-lg">
                      Batchs 
                    </h2>
                  </div>
                  <div
                    class="bg-gray-100 text-green-600 text-sm font-medium px-3 py-1 rounded-md shadow flex gap-1 items-center"
                  >
                    <img
                      src="@/assets/Admin/icon.png"
                      alt=""
                      srcset=""
                      class="object-contain"
                    />
                    +100%
                  </div>
                </div>
                <div>
                  <p class="text-2xl font-bold text-gray-800">
                    <span v-if="studentlist.batch_count">{{
                      studentlist.batch_count
                    }}</span>
                    <span v-else>NA</span>
                  </p>
                  <p class="text-sm text-gray-500">
                    Total Batch
                    <span class="text-[#DB9D39] font-medium">
                      <span v-if="studentlist.batch_count">{{
                        studentlist.batch_count
                      }}</span>
                      <span v-else>NA</span></span
                    >
                  </p>
                </div>
              </div>
            </router-link>
            <router-link :to="{ name: 'HodProgramsDetails' }">
              <div
                class="bg-white shadow-md rounded-2xl p-6 flex flex-col gap-4"
              >
                <div class="flex justify-between items-center">
                  <div class="flex items-center gap-3">
                    <div
                      class="bg-gradient-to-br from-[#3947DB] to-[#3947DB] text-white p-2 flex justify-center items-center rounded-xl"
                    >
                      <img
                        src="@/assets/Admin/Vector(17).png"
                        alt=""
                        srcset=""
                        class="object-contain w-5 h-5"
                      />
                    </div>
                    <h2 class="font-semibold text-gray-700 text-sm 2xl:text-lg">
                      Programs 
                    </h2>
                  </div>
                  <div
                    class="bg-gray-100 text-green-600 text-sm font-medium px-3 py-1 rounded-md shadow flex gap-1 items-center"
                  >
                    <img
                      src="@/assets/Admin/icon.png"
                      alt=""
                      srcset=""
                      class="object-contain"
                    />
                    +100%
                  </div>
                </div>
                <div>
                  <p class="text-2xl font-bold text-gray-800">
                    <span v-if="studentlist.program_count">{{
                      studentlist.program_count
                    }}</span>
                    <span v-else>NA</span>
                  </p>
                  <p class="text-sm text-gray-500">
                    Total Programs
                    <span class="text-[#3947DB] font-medium">
                      <span v-if="studentlist.program_count">{{
                        studentlist.program_count
                      }}</span>
                      <span v-else>NA</span></span
                    >
                  </p>
                </div>
              </div>
            </router-link>
          </div>
          <div class="p-6 flex flex-col md:flex-row gap-5">
            <!-- <div class="w-full lg:w-[50%] 2xl:w-[32%] bg-white shadow-lg rounded-2xl border p-6 flex items-center">
              <RadialChart class="" />
            </div> -->

            <!-- programs -->
            <div
              class="bg-white shadow-lg rounded-2xl overflow-hidden border w-full lg:w-full 2xl:w-full"
            >
              <div class="px-6 py-4 border-b border-gray-200">
                <h2 class="text-xl font-semibold text-gray-800">
                  Programs List
                </h2>
              </div>
              <div class="overflow-x-auto">
                <table class="min-w-full text-left border-collapse">
                  <thead class="bg-gray-100 text-gray-700">
                    <tr>
                      <th class="px-6 py-2">S.No</th>
                      <th class="px-6 py-2">Name</th>
                      <th class="px-6 py-2">shortname</th>
                    </tr>
                  </thead>
                  <tbody v-if="loading" class="bg-[#e5e7eb] w-fit">
                    <tr class="w-full">
                      <td colspan="12" class="text-center py-6">
                        <div class="flex items-center justify-center">
                          <img src="@/assets/attendance/loading.gif" alt="" />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else class="text-gray-700">
                    <template v-if="Programs.length > 0">
                      <tr
                        v-for="(list, index) in Programs"
                        :key="index"
                        class="even:bg-gray-50"
                      >
                        <td class="px-6 py-2">
                          {{ (currentPage - 1) * perPage + index + 1 }}
                        </td>

                        <td class="px-6 py-2 text-textblues">
                          <!-- <span v-if="list.name != null">{{ list.name }}</span
                            ><span v-else>---</span> -->
                          <router-link
                            :to="{
                              name: 'ProgramInnerDetails',
                              params: {
                                program_id: list.id,
                                p_name: list.name,
                              },
                            }"
                          >
                            {{ list.name }}</router-link
                          >
                        </td>
                        <td class="px-6 py-2">
                          <span v-if="list.short_name != null">{{
                            list.short_name
                          }}</span
                          ><span v-else>---</span>
                        </td>
                      </tr>
                    </template>
                    <tr v-else>
                      <td colspan="11" class="px-6 py-3 text-center">
                        No Data Found
                      </td>
                    </tr>
                  </tbody>
                  <!-- <tfoot>
                  <tr>
                    <td colspan="11" class="p-6 bg-[#18469d]"></td>
                  </tr>
                </tfoot> -->
                  <tfoot v-if="totalPages > 1" class="border">
                    <tr>
                      <td colspan="7" class="bg-white">
                        <div class="flex justify-center py-2 space-x-2">
                          <button
                            class="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
                            :disabled="currentPage === 1"
                            @click="prevPage"
                          >
                            &laquo;
                          </button>

                          <button
                            v-for="page in paginationRange"
                            :key="page"
                            class="px-3 py-1 rounded"
                            :class="{
                              'bg-blue-500 text-white': currentPage === page,
                              'bg-white border border-gray-400 text-gray-800':
                                currentPage !== page,
                            }"
                            @click="changePage(page)"
                          >
                            {{ page }}
                          </button>

                          <button
                            class="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
                            :disabled="currentPage >= totalPages"
                            @click="nextPage"
                          >
                            &raquo;
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Hod/Header.vue";
import SideBar from "@/components/Hod/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import MonthChart from "@/components/Hod/MonthChart.vue";
import RadialChart from "@/components/Hod/RadialChart.vue";

export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
    MonthChart,
    RadialChart,
  },
  data() {
    return {
      messages: {
        text: "",
        type: "null",
      },
      organizationdetaill: null,
      studentlist: [],
      currentPage: 1,
      totalPages: 1,
      perPage: 10,

      Programs: [],
    };
  },

  async created() {
    await this.studentlistget();
    await this.programesget();

    let token_id = this.userInfo.token_key;
    await axios
      .get(`${process.env.VUE_APP_API}/organization_detail/?Key=${token_id}`)
      .then((response) => {
        this.organizationdetaill = response.data.data;
      });
  },

  computed: {
    ...mapGetters(["userInfo"]),
    paginationRange() {
      const totalPages = this.totalPages;
      const currentPage = this.currentPage;
      let pages = [];

      if (totalPages <= 5) {
        pages = [...Array(totalPages).keys()].map((x) => x + 1);
      } else {
        if (currentPage > 3) pages.push(1);
        if (currentPage > 4) pages.push("...");

        const startPage = Math.max(2, currentPage - 1);
        const endPage = Math.min(totalPages - 1, currentPage + 1);

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }

        if (currentPage < totalPages - 3) pages.push("...");
        if (currentPage < totalPages - 2) pages.push(totalPages);
      }

      return pages;
    },
  },

  methods: {
    async studentlistget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/users-count-get/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          if (res.data.status == 200) {
            this.studentlist = res.data.data;
            console.log("  this.studentlist", this.studentlist);
          }
        });
    },

    invitepost(el) {
      let bodyVal = {
        email: el.target.elements.studentmail.value,
        coures: this.course_title,
        user: this.userInfo.user.id,
        status: true,
      };
      console.log("bodyVal", bodyVal);
      this.disableStatus = true;
      this.loaders = true;
      axios
        .post(
          `${process.env.VUE_APP_API}/invitation/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.loaders = false;
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.addinvite = false;
              this.disableStatus = false;
              this.searchQuery = "";
              this.inviteget();
            }, 1500);
          } else {
            this.loaders = false;
            this.messages = {
              text: response.data.error,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };

              this.disableStatus = false;
            }, 1500);
          }
        })

        .finally(() => {
          this.loaders = false;
        });
    },

    async programesget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/program-filter-list/?Key=${this.userInfo.token_key}&page=${this.currentPage}`
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.Programs = res.data.data.data;
            this.count_list = res.data.total;
            this.totalnewPages = Math.ceil(res.data.total / this.newperPage);
            console.log("  this.batch", this.batch);
          }
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.programesget();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.programesget();
      }
    },
    changePage(page) {
      if (page !== "..." && page !== this.currentPage) {
        this.currentPage = page;
        this.programesget();
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
